var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "section", staticStyle: { flex: "1" } },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_InventoryInfo")))
          ]),
          _c(
            "div",
            {
              staticClass: "operations",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.cooperateEdit,
                      expression: "cooperateEdit"
                    }
                  ],
                  staticClass: "triggers"
                },
                [
                  !_vm.fbaLob &&
                  _vm.$checkPermission([
                    "button_FBAOverseaWarehousing_dischargeByPallet"
                  ])
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: _vm.isEditing || _vm.isNoInWarehouse
                          },
                          on: { click: _vm.byPalletHandler }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_OutboundByPallet")
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e(),
                  !_vm.fbaLob &&
                  _vm.$checkPermission([
                    "button_FBAOverseaWarehousing_outInCartons"
                  ])
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: _vm.isEditing || _vm.isNoInWarehouse
                          },
                          on: { click: _vm.byBoxHandler }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("CargoMsg.Cargo_OutboundByBox")) +
                              " "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _c("cargo-ag-grid", {
            staticStyle: { "flex-grow": "1", "margin-top": "5px" },
            attrs: {
              "config-module": "9300011",
              "grid-options": _vm.up.goodGridOptions,
              "column-defs": _vm.up.goodsColumn,
              "row-data": _vm.upRowData || []
            },
            on: {
              gridReady: function(params) {
                _vm.up.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "section",
          staticStyle: { float: "left", "padding-top": "10px" }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                "label-width": "65px",
                "label-position": "left",
                disabled: true
              }
            },
            [
              _c("el-form-item", {
                staticClass: "custom",
                attrs: { label: _vm.$t("CargoMsg.Cargo_PalletQuantity") + ":" }
              }),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("CargoMsg.Cargo_Outbound") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "100px" },
                    attrs: { no: "18" },
                    model: {
                      value: _vm.outWarehouseCount,
                      callback: function($$v) {
                        _vm.outWarehouseCount = $$v
                      },
                      expression: "outWarehouseCount"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("CargoMsg.Cargo_NotOutbound") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "100px" },
                    attrs: { no: "19" },
                    model: {
                      value: _vm.noOutWarehouseCount,
                      callback: function($$v) {
                        _vm.noOutWarehouseCount = $$v
                      },
                      expression: "noOutWarehouseCount"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "section",
          staticStyle: { "min-width": "1000px", flex: "1" }
        },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OutboundBatch")))
          ]),
          !_vm.fbaLob
            ? _c("div", { staticClass: "operations" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.cooperateEdit,
                        expression: "cooperateEdit"
                      }
                    ],
                    staticClass: "triggers"
                  },
                  [
                    _vm.$checkPermission([
                      "button_FBAOverseaWarehousing_modifyWarehouseTime"
                    ])
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", disabled: _vm.isEditing },
                            on: { click: _vm.kltzHandler }
                          },
                          [_vm._v("库龄调整")]
                        )
                      : _vm._e(),
                    _vm.$checkPermission([
                      "button_FBAOverseaWarehousing_modifyTheDeliveryTime"
                    ])
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", disabled: _vm.isEditing },
                            on: { click: _vm.xgckbzHandler }
                          },
                          [_vm._v("修改出库备注")]
                        )
                      : _vm._e(),
                    _vm.$checkPermission([
                      "button_FBAOverseaWarehousing_modifyServiceTime"
                    ])
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", disabled: _vm.isEditing },
                            on: { click: _vm.toUpdServiceDate }
                          },
                          [_vm._v("修改送达日期")]
                        )
                      : _vm._e(),
                    _vm.$checkPermission([
                      "button_FBAOverseaWarehousing_withdrawalOfOutbound"
                    ])
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "danger", disabled: _vm.isEditing },
                            on: { click: _vm.cxckHandler }
                          },
                          [_vm._v("撤销出库")]
                        )
                      : _vm._e(),
                    _vm.$checkPermission(["button_FBAOverseaWarehousing_Log"])
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", disabled: _vm.isEditing },
                            on: { click: _vm.logHandler }
                          },
                          [_vm._v("日志")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e(),
          _c("cargo-ag-grid", {
            staticStyle: { "flex-grow": "1", "margin-top": "5px" },
            attrs: {
              "config-module": "9300012",
              "grid-options": _vm.down.goodGridOptions,
              "column-defs": _vm.down.goodsColumn,
              "row-data": _vm.form.fbaOutWarehouses || []
            },
            on: {
              gridReady: function(params) {
                _vm.down.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _vm.byPallet.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.byPallet.visible,
                title: "按托盘出库",
                width: "1200px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.byPallet, "visible", $event)
                }
              }
            },
            [
              _c(
                "cargo-left-right-resize",
                {
                  staticStyle: { height: "100%", "min-height": "300px" },
                  attrs: {
                    "left-style": {
                      display: "flex",
                      flexDirection: "column",
                      width: "40%"
                    },
                    "right-style": {
                      display: "flex",
                      flexDirection: "column",
                      width: "60%"
                    }
                  }
                },
                [
                  _c("template", { slot: "left" }, [
                    _c(
                      "div",
                      { staticClass: "section", staticStyle: { flex: "1" } },
                      [
                        _c(
                          "div",
                          { staticStyle: { "padding-bottom": "8px" } },
                          [
                            _c("span", { staticClass: "title" }, [
                              _vm._v("托盘")
                            ])
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { "padding-bottom": "8px" } },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-right": "8px" },
                                attrs: { no: "1", type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.searchPallet()
                                  }
                                }
                              },
                              [_vm._v("查询")]
                            ),
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                no: "20",
                                placeholder: "根据中文品名过滤托盘"
                              },
                              model: {
                                value: _vm.byPallet.left.cargoName,
                                callback: function($$v) {
                                  _vm.$set(_vm.byPallet.left, "cargoName", $$v)
                                },
                                expression: "byPallet.left.cargoName"
                              }
                            })
                          ],
                          1
                        ),
                        _c("cargo-ag-grid", {
                          staticStyle: { height: "100%" },
                          attrs: {
                            no: "21",
                            "show-side-bar": false,
                            "config-module": "140003",
                            "grid-options": _vm.byPallet.left.gridOptions,
                            "grid-params": _vm.byPallet.left.gridParams,
                            "column-defs": _vm.byPallet.left.downLeftColumnDefs,
                            "row-data": _vm.byPallet.left.downLeftRowData
                          },
                          on: {
                            "update:gridParams": function($event) {
                              return _vm.$set(
                                _vm.byPallet.left,
                                "gridParams",
                                $event
                              )
                            },
                            "update:grid-params": function($event) {
                              return _vm.$set(
                                _vm.byPallet.left,
                                "gridParams",
                                $event
                              )
                            },
                            gridReady: function(params) {
                              return (_vm.byPallet.left.gridApi = params.api)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("template", { slot: "right" }, [
                    _c(
                      "div",
                      { staticClass: "section", staticStyle: { flex: "1" } },
                      [
                        _c(
                          "div",
                          { staticStyle: { "padding-bottom": "8px" } },
                          [
                            _c("span", { staticClass: "title" }, [
                              _vm._v("货物明细")
                            ])
                          ]
                        ),
                        _c("cargo-ag-grid", {
                          staticStyle: { "flex-grow": "1" },
                          attrs: {
                            no: "25",
                            "show-side-bar": false,
                            "config-module": "140004",
                            "grid-options": _vm.byPallet.right.gridOptions,
                            "grid-params": _vm.byPallet.right.gridParams,
                            "column-defs":
                              _vm.byPallet.right.downRightColumnDefs,
                            "row-data":
                              _vm.byPallet.right.downRightRowData || []
                          },
                          on: {
                            "update:gridParams": function($event) {
                              return _vm.$set(
                                _vm.byPallet.right,
                                "gridParams",
                                $event
                              )
                            },
                            "update:grid-params": function($event) {
                              return _vm.$set(
                                _vm.byPallet.right,
                                "gridParams",
                                $event
                              )
                            },
                            gridReady: function(params) {
                              return (_vm.byPallet.right.gridApi = params.api)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                ],
                2
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.chooseByPallet }
                    },
                    [_vm._v("选中")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.byPallet.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.exWarehouse.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.exWarehouse.visible,
                title: _vm.$t("Warehouse.ExWarehouse"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.exWarehouse, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _vm.exWarehouse.opType === "box"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "货箱数量" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { disabled: true, no: "refContainerNo" },
                            model: {
                              value: _vm.exWarehouse.boxesNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.exWarehouse, "boxesNumber", $$v)
                              },
                              expression: "exWarehouse.boxesNumber"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.exWarehouse.opType === "pallet"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "托盘数量" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { disabled: true, no: "refContainerNo" },
                            model: {
                              value: _vm.exWarehouse.palletNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.exWarehouse, "palletNumber", $$v)
                              },
                              expression: "exWarehouse.palletNumber"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "出库模式" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: _vm.exWarehouse.opType !== "box",
                            no: "deliveryMode",
                            placeholder: " "
                          },
                          model: {
                            value: _vm.exWarehouse.deliveryMode,
                            callback: function($$v) {
                              _vm.$set(_vm.exWarehouse, "deliveryMode", $$v)
                            },
                            expression: "exWarehouse.deliveryMode"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "按托盘出库", value: 1 }
                          }),
                          _c("el-option", {
                            attrs: { label: "按箱出库", value: 2 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.exWarehouse.deliveryMode === 1 &&
                  _vm.exWarehouse.opType === "box"
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s("托盘数量"))]
                          ),
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { no: "refContainerNo" },
                            model: {
                              value: _vm.exWarehouse.palletNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.exWarehouse, "palletNumber", $$v)
                              },
                              expression: "exWarehouse.palletNumber"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("Warehouse.DeliveryDate")))]
                      ),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "warehouseOutDate",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("SeaExport.SelectTime")
                        },
                        model: {
                          value: _vm.exWarehouse.warehouseOutDate,
                          callback: function($$v) {
                            _vm.$set(_vm.exWarehouse, "warehouseOutDate", $$v)
                          },
                          expression: "exWarehouse.warehouseOutDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "出库备注" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { no: "remark", type: "textarea", row: 12 },
                        model: {
                          value: _vm.exWarehouse.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.exWarehouse, "remark", $$v)
                          },
                          expression: "exWarehouse.remark"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "操作人" } },
                    [
                      _c("cargo-user-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "op",
                          disabled: true,
                          "method-params": {},
                          "default-value": _vm.exWarehouse.operater || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.exWarehouse.operater = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "物流单号(尾程)" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { no: "refContainerNo" },
                        model: {
                          value: _vm.exWarehouse.logisticsNo,
                          callback: function($$v) {
                            _vm.$set(_vm.exWarehouse, "logisticsNo", $$v)
                          },
                          expression: "exWarehouse.logisticsNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "预计送达时间" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "warehouseOutDate",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("SeaExport.SelectTime")
                        },
                        model: {
                          value: _vm.exWarehouse.preDeliveryTime,
                          callback: function($$v) {
                            _vm.$set(_vm.exWarehouse, "preDeliveryTime", $$v)
                          },
                          expression: "exWarehouse.preDeliveryTime"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "送达时间" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "picker-options": _vm.pickerOptionsForDeliveryTime,
                          no: "warehouseOutDate",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("SeaExport.SelectTime")
                        },
                        model: {
                          value: _vm.exWarehouse.deliveryTime,
                          callback: function($$v) {
                            _vm.$set(_vm.exWarehouse, "deliveryTime", $$v)
                          },
                          expression: "exWarehouse.deliveryTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.exWarehouse.opType === "box"
                            ? _vm.toByBox()
                            : _vm.toByPallet()
                        }
                      }
                    },
                    [_vm._v("提交")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.exWarehouse.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.byBox.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.byBox.visible,
                title: "按箱出库",
                width: "1200px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.byBox, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "section", staticStyle: { flex: "1" } },
                [
                  _c(
                    "div",
                    { staticStyle: { "padding-bottom": "8px" } },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            inline: true,
                            "label-width": "80px",
                            "label-position": "left"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "1", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.byBoxSearchNoOut()
                                    }
                                  }
                                },
                                [_vm._v("查询")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "货箱编号" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "60px" },
                                  attrs: { no: "4", placeholder: " " },
                                  model: {
                                    value: _vm.byBox.containerNoOpt,
                                    callback: function($$v) {
                                      _vm.$set(_vm.byBox, "containerNoOpt", $$v)
                                    },
                                    expression: "byBox.containerNoOpt"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "等于", value: "=" }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "不等于", value: "!=" }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "包含", value: "LIKE" }
                                  })
                                ],
                                1
                              ),
                              _c("el-input", {
                                staticStyle: {
                                  width: "150px",
                                  "padding-left": "8px"
                                },
                                attrs: { no: "5" },
                                model: {
                                  value: _vm.byBox.containerNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.byBox, "containerNo", $$v)
                                  },
                                  expression: "byBox.containerNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "padding-bottom": "8px" } },
                    [
                      _vm._v(
                        " 已选中 " +
                          _vm._s(_vm.byBox.selectedCount) +
                          " / " +
                          _vm._s(_vm.byBox.rowData.length || 0) +
                          " "
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "2" },
                          on: {
                            click: function($event) {
                              return _vm.byBoxPick()
                            }
                          }
                        },
                        [_vm._v("拣选")]
                      ),
                      _c("el-input-number", {
                        staticStyle: { "padding-left": "8px" },
                        attrs: {
                          no: "3",
                          "controls-position": "right",
                          min: 0,
                          precision: 0
                        },
                        model: {
                          value: _vm.byBox.upQuantity,
                          callback: function($$v) {
                            _vm.$set(_vm.byBox, "upQuantity", $$v)
                          },
                          expression: "byBox.upQuantity"
                        }
                      }),
                      _vm._v(" 件 ")
                    ],
                    1
                  ),
                  _c("cargo-ag-grid", {
                    staticStyle: {
                      width: "100%",
                      flex: "1",
                      "min-height": "350px"
                    },
                    attrs: {
                      no: "10",
                      "config-module": "140005",
                      "grid-options": _vm.byBox.gridOptions,
                      "grid-params": _vm.byBox.gridParams,
                      "column-defs": _vm.byBox.columnDefs,
                      "row-data": _vm.byBox.rowData
                    },
                    on: {
                      "update:gridParams": function($event) {
                        return _vm.$set(_vm.byBox, "gridParams", $event)
                      },
                      "update:grid-params": function($event) {
                        return _vm.$set(_vm.byBox, "gridParams", $event)
                      },
                      gridReady: function(params) {
                        return (_vm.byBox.gridApi = params.api)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.chooseByBox }
                    },
                    [_vm._v("选中")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.byBox.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.issueRemarks.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.issueRemarks.visible,
                title: this.issueRemarks.type,
                width: "700px",
                heignt: "900px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.issueRemarks, "visible", $event)
                }
              }
            },
            [
              _vm.issueRemarks.state === 1
                ? _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入备注",
                      maxlength: "300",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.issueRemarks.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.issueRemarks, "remark", $$v)
                      },
                      expression: "issueRemarks.remark"
                    }
                  })
                : _vm._e(),
              _vm.issueRemarks.state === 2
                ? _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "value-format": "yyyy-MM-dd HH:mm",
                      no: "warehouseOutDate",
                      type: "datetime",
                      format: "yyyy-MM-dd HH:mm"
                    },
                    model: {
                      value: _vm.issueRemarks.deliveryTime,
                      callback: function($$v) {
                        _vm.$set(_vm.issueRemarks, "deliveryTime", $$v)
                      },
                      expression: "issueRemarks.deliveryTime"
                    }
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.submitIssurRemarks }
                    },
                    [_vm._v("提交")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.issueRemarks.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.storageAgeEdit.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "station-edit-dialog",
              attrs: {
                visible: _vm.storageAgeEdit.visible,
                title: _vm.$t("Warehouse.storageAgeEdit"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.storageAgeEdit, "visible", $event)
                }
              }
            },
            [
              _vm.storageAgeEdit.visible
                ? _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row",
                      staticStyle: { "padding-bottom": "10px" }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-width": "110px",
                            "label-position": "left"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Warehouse.storageAgeEditDay")
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: {
                                  width: "50px",
                                  "margin-right": "8px"
                                },
                                attrs: { no: "storageAgeDayEst", disabled: "" },
                                model: {
                                  value: _vm.storageAgeEdit.storageAgeDayEst,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.storageAgeEdit,
                                      "storageAgeDayEst",
                                      $$v
                                    )
                                  },
                                  expression: "storageAgeEdit.storageAgeDayEst"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-family":
                                      "'Open Sans', Arial, sans-serif"
                                  }
                                },
                                [_vm._v("/")]
                              ),
                              _c("el-input", {
                                staticStyle: {
                                  width: "50px",
                                  "margin-left": "8px"
                                },
                                attrs: { no: "storageAgeDay" },
                                model: {
                                  value: _vm.storageAgeEdit.storageAgeDay,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.storageAgeEdit,
                                      "storageAgeDay",
                                      $$v
                                    )
                                  },
                                  expression: "storageAgeEdit.storageAgeDay"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Warehouse.storageAgeEditWeek")
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: {
                                  width: "50px",
                                  "margin-right": "8px"
                                },
                                attrs: {
                                  no: "storageAgeWeekEst",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.storageAgeEdit.storageAgeWeekEst,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.storageAgeEdit,
                                      "storageAgeWeekEst",
                                      $$v
                                    )
                                  },
                                  expression: "storageAgeEdit.storageAgeWeekEst"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-family":
                                      "'Open Sans', Arial, sans-serif"
                                  }
                                },
                                [_vm._v("/")]
                              ),
                              _c("el-input", {
                                staticStyle: {
                                  width: "50px",
                                  "margin-left": "8px"
                                },
                                attrs: { no: "storageAgeWeek" },
                                model: {
                                  value: _vm.storageAgeEdit.storageAgeWeek,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.storageAgeEdit,
                                      "storageAgeWeek",
                                      $$v
                                    )
                                  },
                                  expression: "storageAgeEdit.storageAgeWeek"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "save" },
                      on: { click: _vm.storageAgeSaveCallBack }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "cancel" },
                      on: {
                        click: function($event) {
                          _vm.storageAgeEdit.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.batchLog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.batchLog.visible,
                title: _vm.$t("CargoMsg.Cargo_Log"),
                width: "700px",
                heignt: "900px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.batchLog, "visible", $event)
                }
              }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: {
                  width: "100%",
                  flex: "1",
                  "min-height": "350px"
                },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.batchLog.gridOptions,
                  "column-defs": _vm.batchLog.columnDefs,
                  "row-data": _vm.batchLog.rowData
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }